import React, { useEffect, useState } from 'react';
import { Github, Linkedin } from 'lucide-react';

export const Header: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass py-3' : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto flex items-center justify-between px-6">
        <a href="/" className="group flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl tech-gradient text-xl font-black text-white shadow-lg shadow-primary-500/20 transition-transform group-hover:scale-105">
            TT
          </div>
          <div>
            <span className="block text-xl font-extrabold tracking-normal text-primary-950">
              TECHTAITAN
            </span>
            <span className="block text-[10px] font-black uppercase tracking-[0.24em] text-primary-400">
              AI Professional Systems
            </span>
          </div>
        </a>

        <nav className="hidden items-center gap-3 md:flex">
          <a
            href="#thesis"
            className="rounded-full border border-primary-100 bg-white/70 px-5 py-2.5 text-sm font-black uppercase tracking-widest text-primary-900 transition-all hover:border-primary-300"
          >
            Thesis
          </a>
          <a
            href="#expertise"
            className="rounded-full border border-primary-100 bg-white/70 px-5 py-2.5 text-sm font-black uppercase tracking-widest text-primary-900 transition-all hover:border-primary-300"
          >
            Expertise
          </a>
          <a
            href="#builds"
            className="rounded-full border border-primary-100 bg-white/70 px-5 py-2.5 text-sm font-black uppercase tracking-widest text-primary-900 transition-all hover:border-primary-300"
          >
            Builds
          </a>
          <a
            href="#notes"
            className="rounded-full border border-primary-100 bg-white/70 px-5 py-2.5 text-sm font-black uppercase tracking-widest text-primary-900 transition-all hover:border-primary-300"
          >
            Notes
          </a>
          <a
            href="https://www.linkedin.com/"
            className="rounded-full bg-primary-900 px-5 py-2.5 text-sm font-black uppercase tracking-widest text-white transition-all hover:bg-primary-800"
          >
            LinkedIn
          </a>
        </nav>
      </div>
    </header>
  );
};

export const Footer: React.FC = () => {
  return (
    <footer className="border-t border-primary-100 bg-white py-10">
      <div className="container mx-auto flex flex-col justify-between gap-8 px-6 md:flex-row md:items-center">
        <div>
          <div className="mb-2 flex items-center gap-2">
            <div className="flex h-8 w-8 items-center justify-center rounded-lg tech-gradient font-bold text-white">
              TT
            </div>
            <span className="text-xl font-black text-primary-950">TechTaitan</span>
          </div>
          <p className="max-w-xl font-medium text-primary-700">
            A professional authority profile on AI-native systems for tax, accounting, law, and
            finance.
          </p>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#"
            aria-label="GitHub"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-primary-100 bg-beige-100 text-primary-700 transition-all hover:border-primary-300 hover:text-primary"
          >
            <Github className="h-5 w-5" />
          </a>
          <a
            href="#"
            aria-label="LinkedIn"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-primary-100 bg-beige-100 text-primary-700 transition-all hover:border-primary-300 hover:text-primary"
          >
            <Linkedin className="h-5 w-5" />
          </a>
        </div>
      </div>
    </footer>
  );
};
